import { PayloadAction } from '@reduxjs/toolkit';
import createAsyncSlice from '../createAsyncSlice';

/**
 * Represents the state of the layout.
 */
export interface LayoutSliceState {
  sideBarOpen: boolean;
  headerTitle: string;
  status: 'idle' | 'loading' | 'failed';
}

/**
 * Represents the initial state of the layout.
 */
const initialState: LayoutSliceState = {
  sideBarOpen: false,
  headerTitle: 'Explore',
  status: 'idle',
};

/**
 * Creates reducers and selectors with which to used to interact with the layout state.
 */
export const layoutSlice = createAsyncSlice({
  name: 'layoutSlice',
  initialState,
  reducers: create => ({
    // Update's the state's sidebarOpen value
    setSidebarOpen: create.reducer((state, action: PayloadAction<boolean>) => {
      state.sideBarOpen = action.payload;
    }),
    // Update's the state's setHeaderTitle value
    setHeaderTitle: create.reducer((state, action: PayloadAction<string>) => {
      state.headerTitle = action.payload;
    }),
  }),
  selectors: {
    sidebarOpenSelector: state => state.sideBarOpen,
    headerTitleSelector: state => state.headerTitle,
  },
});

export const { setSidebarOpen, setHeaderTitle } = layoutSlice.actions;

export const { sidebarOpenSelector, headerTitleSelector } = layoutSlice.selectors;
